import { render, staticRenderFns } from "./imgZoom.vue?vue&type=template&id=1644cd94&scoped=true"
import script from "./imgZoom.vue?vue&type=script&lang=js"
export * from "./imgZoom.vue?vue&type=script&lang=js"
import style0 from "./imgZoom.vue?vue&type=style&index=0&id=1644cd94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1644cd94",
  null
  
)

export default component.exports